import { RouteObject } from '@suntex.core/nav'
import { RequireAuth } from '@suntex.fim/framework'
import { AdminLayout } from '@suntex.fim/nav'

import Admin from '../pages/app/Admin/Admin'
import AdminEntityChildrenList from '../pages/app/Admin/AdminEntityChildrenList'
import AdminEntityEdit from '../pages/app/Admin/AdminEntityEdit'
import FeedbackMessages from '../pages/app/FeedbackMessages'
import MyAccount from '../pages/app/MyAccount'

import { layoutChrome } from './navChrome'

export const adminRoutes: RouteObject[] = [
  {
    path: '/admin',
    element: <RequireAuth />,
    children: [
      {
        element: <AdminLayout {...layoutChrome} />,
        children: [
          {
            path: '',
            Component: Admin
          },
          {
            path: 'messages',
            Component: FeedbackMessages
          },
          {
            path: ':entityLevel/:entityId/edit',
            Component: AdminEntityEdit
          },
          {
            path: ':entityLevel/:entityId/:childEntityLevels',
            Component: AdminEntityChildrenList
          }
        ]
      }
    ]
  },
  {
    path: '/admin/:entityLevel/:entityId/edit',
    Component: AdminEntityEdit
  },
  {
    path: '/admin/:entityLevel/:entityId/:childEntityLevels',
    Component: AdminEntityChildrenList
  },
  {
    path: '/my-account',
    element: <AdminLayout {...layoutChrome} />,
    children: [
      {
        path: '',
        Component: MyAccount
      }
    ]
  }
]
